import React from 'react';
import './KnowledgeContainer.css';

export default function KnowledgeContainer(props) {
    return (
        <div>   
        <i className="fas fa-check check-icon"></i>
        <span className="regular-text">{props.text}</span>
    </div>
    )
}
